import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "share",
  "use": "share-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"share\"><g fill-rule=\"evenodd\"><path d=\"M4 7h11v10H4z\" opacity=\".09\" /><path d=\"M4 16h11v1H4z\" opacity=\".09\" /><path d=\"M10 4.143V7h4c1.1 0 2 .9 2 2v7c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h4V4.143L6 5l3.5-3L13 5l-3-.857ZM9 8H4.846C4.372 8 4 8.45 4 9v7c0 .54.38 1 .846 1h9.308c.474 0 .846-.45.846-1V9c0-.54-.38-1-.846-1H10v5H9V8Zm1 0h2V7h-2v1ZM9 8H7V7h2v1Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol